import React from "react";
import { Link } from "react-router-dom";
import { TagGroup, Tag, Icons } from "./Tag/Tag";
import { useLang } from "./LanguageContext";

const content = {
  en: {
    title: "Code",
    bannerHeader: "Built before the LLM era",
    bannerText:
      "The projects below were written by hand, before AI coding assistants were part of everyday development. They are kept here as a record of that work.",
    categories: {
      teaching: "Teaching",
      webDev: "Web Development",
      pythonNotebooks: "Python Notebooks",
      dataDashboards: "Data Dashboards",
      dataEngineering: "Data Engineering",
      juliaNotebooks: "Julia Notebooks",
    },
    projects: {
      interiorPoint: "Linear Optimization - Interior point method example",
      dogCeo: "Dog CEO Challenge",
      dogCeoDesc:
        "Web application, using React, that allows for the search and filtering of images associated with different dog breeds and sub-breeds",
      ecommerce: "E-commerce",
      ecommerceDesc:
        "Implementation in vanilla javascript with Python backend.",
      budgetApp: "Budget App",
      budgetAppDesc:
        "This website was made with Django for the backend and with Javascript for the frontend. I used Javascript to manipulate the DOM and html templates. Django is used for ORM, routing and API requests.",
      bisection: "Bisection Method",
      bisectionDesc:
        "React App with Python backend for finding root of univariate functions with bisection method. It uses plotly in the backend for plotting and own implementation of the algorithm was used to solve",
      newton: "Newton's Method",
      newtonDesc:
        "React App with Python backend for finding root of univariate functions with newton's method. It uses plotly in the backend for plotting and own implementation of the algorithm was used to solve",
      tsp: "Travelling Salesman Problem",
      tspDesc:
        "React App with Python backend for finding optimal route in the city of Guayaquil. It uses ortools in the backend",
      centerOfGravity:
        "Center of Gravity Method with Automatic Differentiation for Facility Location",
      centerOfGravityDesc:
        "iPython notebook with code for solving the Facility Location problem with unconstrained optimization",
      simplex: "Simplex algorithm in Numpy",
      simplexDesc:
        "iPython notebook with implementation of simplex algorithm on numpy",
      hevrp: "Heterogeneous Vehicle Routing Problem in gurobipy",
      hevrpDesc:
        "iPython notebook with code for solving the heterogeneous vehicle routing problem. It uses gurobi solver",
      covid: "COVID-19 data",
      covidDesc:
        "Dashboard that presents COVID-19 data. It uses Python's library Dash for implementation.",
      webApi: "Web API data with Airflow and plotly",
      webApiDesc:
        "Dashboard that presents data from an API. The application is made up a Airflow app that schedules daily updates to the Webpage's database. The webpage is a plotly's Dash app that reads data from a PostgreSQL database and present it in a table. The table is capable of filtering and searching.",
      datasette: "Web API data with Datasette",
      datasetteDesc:
        "Extracts and loads Web API data into a SQLite database. It makes available the data by querying using Datasettte. It allows querying the data using filters or SQL. The app is constructed using Modal which allows to refresh the database every 24h.",
      dataPipeline: "Data Pipeline",
      dataPipelineDesc:
        "ETL pipeline with PySpark on AWS EMR orchestrated with Airflow",
      dataflow: "Dataflow",
      dataflowDesc:
        "ETL pipeline with Apache Beam on Google's Dataflow runner",
      extractLoad: "Extract-and-Load to Database",
      extractLoadDesc: "React app to upload file data to database",
      policyIteration: "Policy Iteration in Julia",
      policyIterationDesc:
        "Implementation of reinforcement learning algorithm in Julia",
      gradientDescent:
        "An implementation of Gradient Descent for optimization in Julia",
      gradientDescentDesc:
        "Implementation of unconstrained optimization algorithm in Julia",
      newtonOpt:
        "An implementation of Newton Method for optimization in Julia",
      newtonOptDesc:
        "Implementation of unconstrained optimization algorithm in Julia",
    },
  },
  es: {
    title: "Código",
    bannerHeader: "Construido antes de la era LLM",
    bannerText:
      "Los proyectos a continuación fueron escritos a mano, antes de que los asistentes de programación con IA fueran parte del desarrollo cotidiano. Se conservan aquí como registro de ese trabajo.",
    categories: {
      teaching: "Enseñanza",
      webDev: "Desarrollo Web",
      pythonNotebooks: "Cuadernos de Python",
      dataDashboards: "Dashboards de Datos",
      dataEngineering: "Ingeniería de Datos",
      juliaNotebooks: "Cuadernos de Julia",
    },
    projects: {
      interiorPoint: "Optimización Lineal - Ejemplo del método de punto interior",
      dogCeo: "Dog CEO Challenge",
      dogCeoDesc:
        "Aplicación web con React que permite buscar y filtrar imágenes de diferentes razas y sub-razas de perros",
      ecommerce: "E-commerce",
      ecommerceDesc:
        "Implementación en JavaScript vanilla con backend en Python.",
      budgetApp: "App de Presupuesto",
      budgetAppDesc:
        "Este sitio web fue desarrollado con Django para el backend y Javascript para el frontend. Se usó Javascript para manipular el DOM y las plantillas HTML. Django se usa para ORM, enrutamiento y peticiones API.",
      bisection: "Método de Bisección",
      bisectionDesc:
        "App React con backend en Python para encontrar raíces de funciones univariadas usando el método de bisección. Usa plotly en el backend para graficar y una implementación propia del algoritmo.",
      newton: "Método de Newton",
      newtonDesc:
        "App React con backend en Python para encontrar raíces de funciones univariadas con el método de Newton. Usa plotly en el backend para graficar y una implementación propia del algoritmo.",
      tsp: "Problema del Viajante de Comercio",
      tspDesc:
        "App React con backend en Python para encontrar la ruta óptima en la ciudad de Guayaquil. Usa ortools en el backend.",
      centerOfGravity:
        "Método del Centro de Gravedad con Diferenciación Automática para Localización de Instalaciones",
      centerOfGravityDesc:
        "Cuaderno iPython con código para resolver el problema de Localización de Instalaciones con optimización sin restricciones",
      simplex: "Algoritmo Simplex en Numpy",
      simplexDesc:
        "Cuaderno iPython con implementación del algoritmo simplex en numpy",
      hevrp: "Problema de Ruteo de Vehículos Heterogéneos en gurobipy",
      hevrpDesc:
        "Cuaderno iPython con código para resolver el problema de ruteo de vehículos heterogéneos usando el solver gurobi",
      covid: "Datos COVID-19",
      covidDesc:
        "Dashboard que presenta datos de COVID-19. Usa la biblioteca Dash de Python.",
      webApi: "Datos de API Web con Airflow y plotly",
      webApiDesc:
        "Dashboard que presenta datos de una API. La aplicación incluye una app de Airflow que programa actualizaciones diarias a la base de datos de la página web. La página es una app de Dash que lee datos de una base de datos PostgreSQL y los presenta en una tabla con capacidad de filtrado y búsqueda.",
      datasette: "Datos de API Web con Datasette",
      datasetteDesc:
        "Extrae y carga datos de una API Web en una base de datos SQLite. Pone los datos a disposición mediante consultas con Datasette, permitiendo filtros o SQL. La app se construyó con Modal que permite refrescar la base de datos cada 24h.",
      dataPipeline: "Pipeline de Datos",
      dataPipelineDesc:
        "Pipeline ETL con PySpark en AWS EMR orquestado con Airflow",
      dataflow: "Dataflow",
      dataflowDesc:
        "Pipeline ETL con Apache Beam en el runner Dataflow de Google",
      extractLoad: "Extracción y Carga a Base de Datos",
      extractLoadDesc:
        "App React para cargar datos de archivos a una base de datos",
      policyIteration: "Iteración de Política en Julia",
      policyIterationDesc:
        "Implementación de algoritmo de aprendizaje por refuerzo en Julia",
      gradientDescent:
        "Implementación de Descenso de Gradiente para optimización en Julia",
      gradientDescentDesc:
        "Implementación de algoritmo de optimización sin restricciones en Julia",
      newtonOpt:
        "Implementación del Método de Newton para optimización en Julia",
      newtonOptDesc:
        "Implementación de algoritmo de optimización sin restricciones en Julia",
    },
  },
};

const NotesMenu = () => {
  const { lang } = useLang();
  const t = content[lang];
  const p = t.projects;
  const cat = t.categories;

  return (
    <div>
      <h1 className="ui header">
        <span className="hand-drawn-highlight">{t.title}</span>
      </h1>
      <div className="ui icon info message">
        <i className="history icon"></i>
        <div className="content">
          <div className="header">{t.bannerHeader}</div>
          <p>{t.bannerText}</p>
        </div>
      </div>
      <div className="ui list">
        {/* Teaching */}
        <div className="item">
          <i className="pencil alternate icon"></i>
          <div className="content">
            <div className="header">{cat.teaching}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/interiorpoint" className="item">
                    {p.interiorPoint}
                  </Link>
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>
                    Algorithms
                  </Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>

        {/* Web Development */}
        <div className="item">
          <i className="laptop icon"></i>
          <div className="content">
            <div className="header">{cat.webDev}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/dogCeoInfo" className="item">
                    {p.dogCeo}
                  </Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.dogCeoDesc}
                </div>
                <TagGroup>
                  <Tag color="purple" icon={Icons.square}>API Rest</Tag>
                  <Tag color="pink" icon={Icons.circle}>React</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://github.com/jomavera/test-store" target="_blank" rel="noopener noreferrer">{p.ecommerce}</a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.ecommerceDesc}
                </div>
                <TagGroup>
                  <Tag color="pink" icon={Icons.circle}>Python</Tag>
                  <Tag color="pink" icon={Icons.circle}>Javascript</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://github.com/jomavera/budgetApp" target="_blank" rel="noopener noreferrer">{p.budgetApp}</a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.budgetAppDesc}
                </div>
                <TagGroup>
                  <Tag color="purple" icon={Icons.square}>Django</Tag>
                  <Tag color="pink" icon={Icons.circle}>Javascript</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/biseccion" className="item">{p.bisection}</Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.bisectionDesc.split("plotly").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<code>plotly</code></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>React</Tag>
                  <Tag color="pink" icon={Icons.circle}>plotly</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/newton" className="item">{p.newton}</Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.newtonDesc.split("plotly").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<code>plotly</code></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>React</Tag>
                  <Tag color="pink" icon={Icons.circle}>plotly</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/tsp" className="item">{p.tsp}</Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.tspDesc.split("ortools").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<code>ortools</code></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>React</Tag>
                  <Tag color="pink" icon={Icons.circle}>OR-Tools</Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>

        {/* Python Notebooks */}
        <div className="item">
          <i className="python icon"></i>
          <div className="content">
            <div className="header">{cat.pythonNotebooks}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/Center of Gravity with JAX.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.centerOfGravity}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.centerOfGravityDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>Python</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/SimplexAlgorithm.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.simplex}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.simplexDesc.split("numpy").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<code>numpy</code></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>Python</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/HEVRP_Gurobi.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.hevrp}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.hevrpDesc.split("gurobi").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<code>gurobi</code></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                  <Tag color="pink" icon={Icons.circle}>Python</Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>

        {/* Data Dashboards */}
        <div className="item">
          <i className="chart bar icon"></i>
          <div className="content">
            <div className="header">{cat.dataDashboards}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/covidInfo" className="item">{p.covid}</Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.covidDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Data Visualization</Tag>
                  <Tag color="pink" icon={Icons.circle}>Python</Tag>
                  <Tag color="purple" icon={Icons.square}>Dash</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <Link to="/webapiInfo" className="item">{p.webApi}</Link>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.webApiDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Data Visualization</Tag>
                  <Tag color="pink" icon={Icons.circle}>plotly</Tag>
                  <Tag color="purple" icon={Icons.square}>Airflow</Tag>
                  <Tag color="purple" icon={Icons.square}>Dash</Tag>
                  <Tag color="purple" icon={Icons.square}>API Rest</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://jomavera--el-rosado-datasette-app-dev.modal.run/" target="_blank" rel="noopener noreferrer">
                    {p.datasette}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.datasetteDesc.split("Modal").map((part, i, arr) =>
                    i < arr.length - 1 ? (
                      <React.Fragment key={i}>{part}<a href="https://modal.com/" target="_blank" rel="noopener noreferrer">Modal</a></React.Fragment>
                    ) : part
                  )}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Data Visualization</Tag>
                  <Tag color="pink" icon={Icons.circle}>Datasette</Tag>
                  <Tag color="purple" icon={Icons.square}>SQLite</Tag>
                  <Tag color="purple" icon={Icons.square}>API Rest</Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>

        {/* Data Engineering */}
        <div className="item">
          <i className="server icon"></i>
          <div className="content">
            <div className="header">{cat.dataEngineering}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://github.com/jomavera/dataPipelineEMR" target="_blank" rel="noopener noreferrer">{p.dataPipeline}</a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.dataPipelineDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>ETL</Tag>
                  <Tag color="pink" icon={Icons.circle}>PySpark</Tag>
                  <Tag color="purple" icon={Icons.square}>AWS EMR</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://github.com/jomavera/apacheBeam-example" target="_blank" rel="noopener noreferrer">{p.dataflow}</a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.dataflowDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>ETL</Tag>
                  <Tag color="pink" icon={Icons.circle}>Apache Beam</Tag>
                  <Tag color="purple" icon={Icons.square}>GCP Dataflow</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://github.com/jomavera/minimal_db_project" target="_blank" rel="noopener noreferrer">{p.extractLoad}</a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.extractLoadDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>ETL</Tag>
                  <Tag color="pink" icon={Icons.circle}>React</Tag>
                  <Tag color="pink" icon={Icons.circle}>SQL</Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>

        {/* Julia Notebooks */}
        <div className="item">
          <i className="code icon"></i>
          <div className="content">
            <div className="header">{cat.juliaNotebooks}</div>
            <div className="ui link list">
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/hex_problem_nb.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.policyIteration}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.policyIterationDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/gradientDescent.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.gradientDescent}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.gradientDescentDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                </TagGroup>
              </div>
              <div className="item">
                <i className="angle right icon"></i>
                <div className="content">
                  <a href="https://nbviewer.jupyter.org/github/jomavera/Misc./blob/master/newtonOpt.ipynb" target="_blank" rel="noopener noreferrer">
                    {p.newtonOpt}
                  </a>
                </div>
                <div className="description" style={{ paddingLeft: "20px" }}>
                  {p.newtonOptDesc}
                </div>
                <TagGroup>
                  <Tag color="blue" icon={Icons.triangle}>Algorithms</Tag>
                </TagGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesMenu;
